import ACHNowManagement from "../../pages/dashboard/feature-management/ACHNowManagement";
import ACHNowManagementDetails from "../../pages/dashboard/feature-management/ACHNowManagementDetails";
import { ALL_ROUTES } from "../AllRoutes";

export const feature_management_routes_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_FEATURE_MANAGEMENT,
    element: ACHNowManagement,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_FEATURE_MANAGEMENT_DETAILS,
    element: ACHNowManagementDetails,
  },
];
